import React, { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { Link } from "react-router-dom";
import { useLoginUser } from "../adapters/uplist";
import { TempPasswordNotice } from "../components/order/TempPasswordNotice";
import { useModal } from "../hooks";
import { ForgotPasswordModal } from "./ForgotPasswordPage";
import AuthPage from "./hoc/AuthPage";
import { Input } from "../components/fields";

const LoginPage = () => {
  const ref = useRef();
  const methods = useForm();
  return (
    <FormProvider formRef={ref} {...methods}>
      <AuthPage>
        <LoginForm />
      </AuthPage>
    </FormProvider>
  );
};

const LoginForm = () => {
  const { mutate } = useLoginUser();
  const { handleSubmit, formRef } = useFormContext();
  const { handleModal } = useModal();
  const [resetSent, setResetSent] = useState(false);
  return (
    <Form ref={formRef} onSubmit={handleSubmit(mutate)} noValidate>
      <TempPasswordNotice />
      <Input
        name="email"
        type="email"
        label="Email"
        autoComplete="username"
        required
      />
      <Input
        name="password"
        type="password"
        label="Password"
        autoComplete="current-password"
        password
        required
      />
      <p
        className="mb-3 text-link"
        onClick={() => {
          handleModal(
            <ForgotPasswordModal onSent={() => setResetSent(true)} />,
            {
              centered: true,
              id: "OrderModal",
            }
          );
        }}
      >
        Forgot your Password?
      </p>
      {resetSent && (
        <p>
          Your email is on its way. Once you have set your password you can log
          in.
        </p>
      )}
      <Button className="mb-3" type="submit" size="lg" block>
        Sign In
      </Button>
      <p className="text-center">OR</p>
      <Button as={Link} variant="link" to="/new-order" block>
        Start Your Order
      </Button>
    </Form>
  );
};

export default LoginPage;
